<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <!-- 左边 -->
        <div style="margin-top:10px">
            <el-select v-model="building" clearable placeholder="请选择楼栋" size="small" style="margin: 5px;width: 130px"
                @change="getfloor">
                <el-option v-for="item in building_options" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="floor" clearable placeholder="请选择楼层" size="small" style="margin: 5px;width: 130px">
                <el-option v-for="item in floor_options" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="room_cx" clearable placeholder="请选择朝向" size="small" style="margin: 5px;width: 130px">
                <el-option v-for="item in room_cx_options" :key="item.id" :label="item.content_name" :value="item.id">
                </el-option>
            </el-select>
            <el-button size="mini" type="success" @click="searchs" style="margin: 5px;">搜索</el-button>
            <el-button size="mini" type="success" @click="openModel" style="margin: 5px; float: right">添加房间</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="building_id_text" label="楼栋" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="floor_id_text" label="楼层" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="room_type_text" label="房型" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="room_num" label="房间号" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="room_cx_text" label="朝向" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="jzmj" label="面积/m²" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="min_price" label="价格" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="sort" label="排序" show-overflow-tooltip align="center"></el-table-column>
            <!-- <el-table-column prop="jzmj" label="最高价/元" show-overflow-tooltip align="center"></el-table-column> -->
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <el-button @click="setClick(scope.row)" type="primary" size="mini">床位设置</el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="float: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[10, 15, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="楼栋">
                        <el-select v-model="ruleForm.building_id" placeholder="请选择" size="small" style="width: 30%"
                            @change="getfloor">
                            <el-option v-for="item in building_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="楼层">
                        <el-select v-model="ruleForm.floor_id" placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in floor_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="房间">
                        <el-select v-model="ruleForm.room_type" placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in room_options" :key="item.id" :label="item.room_type_text"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="朝向">
                        <el-select v-model="ruleForm.room_cx" placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in room_cx_options" :key="item.id" :label="item.content_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="状态">
                        <el-select v-model="ruleForm.status" placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in status_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="房间号">
                        <el-input v-model="ruleForm.room_num" placeholder="请输入内容" style="width: 30%"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sort" placeholder="请输入内容" style="width: 30%"></el-input>
                    </el-form-item>
                    <el-form-item label="面积">
                        <el-input v-model="ruleForm.jzmj" placeholder="请输入内容" style="width: 30%"></el-input><span
                            style="font-size: 20px">/m²</span>
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input v-model="ruleForm.min_price" placeholder="请输入内容" style="width: 30%"></el-input>
                        <span style="font-size: 20px">/元</span>
                    </el-form-item>
                    <!-- <el-form-item label="最高价格">
                        <el-input v-model="ruleForm.max_price" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item> -->
                    <el-form-item label="描述">
                        <!-- <el-input v-model="ruleForm.describe" placeholder="请输入内容" style="width: 30%"></el-input> -->
                        <WangEditor ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.describe"
                            :operateflag="operateflag" />
                    </el-form-item>
                    <!-- <el-form-item label="图片">
                        <div>
                            <span v-if="!ruleForm.pic[0]" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.pic[0]" class="rounded"
                                style="width: 100px; height: 100px; cursor: pointer" @click="chooseImage" />
                        </div>
                    </el-form-item> -->
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button @click="subForm" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="床位设置" :visible.sync="dialogVisibles" top="20px" :append-to-body="true">
            <div style="margin: 5px; float: right">
                <el-button size="mini" type="success" @click="openModelbad">添加床位</el-button>
            </div>
            <el-table :data="tableDatabed" border style="width: 100%" v-loading="bedloadings"
                ref="configurationTablebed">
                <el-table-column prop="bed_num" label="床位号" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="status_text" label="使用状态" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button @click="handleClickbed(scope.row)" type="primary" size="mini">编辑</el-button>
                        <el-button @click="deleteClickbed(scope.row)" type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog :title="badnames" :visible.sync="dialogVisibled" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForms" :rules="ruled" ref="ruleForms" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="床位号">
                        <el-input v-model="ruleForms.bed_num" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForms.sort" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="使用状态">
                        <el-radio v-model="ruleForms.status" label="1">空</el-radio>
                        <el-radio v-model="ruleForms.status" label="2">住(男)</el-radio>
                        <el-radio v-model="ruleForms.status" label="3">住(女)</el-radio>
                        <!-- <el-radio v-model="ruleForms.status" label="3">暂停使用</el-radio> -->
                    </el-form-item>
                    <!-- <el-form-item label="使用者性别" v-if="ruleForms.status == '2'">
                        <el-select v-model="ruleForms.user_sex" placeholder="请选择" size="small" style="width: 50%">
                            <el-option v-for="item in sex_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用时间" v-if="ruleForms.status == '2'">
                        <el-date-picker v-model="ruleForms.enter_date" type="datetime" placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item> -->
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibled = false" size="small">取 消</el-button>
                <el-button @click="subFormbad" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    const WangEditor = () => import("@/components/wangEnduit/index");
    export default {
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor
        },
        data() {
            return {
                building: '',
                room_cx: '',
                floor: '',
                tableData: [],
                loadings: false,
                height: null,
                pageSize: 10,
                curPage: 1,
                count: 0,
                names: "",
                dialogVisible: false,
                building_options: [],
                floor_options: [],
                room_options: [],
                room_cx_options: [],
                operateflag: "add",
                status_options: [{
                        id: 1,
                        name: '空(全空)'
                    },
                    {
                        id: 2,
                        name: '空(男)'
                    },
                    {
                        id: 3,
                        name: '空(女)'
                    },
                    {
                        id: 4,
                        name: '满'
                    },
                ],
                ruleForm: {
                    building_id: "",
                    // status: '',
                    floor_id: "",
                    room_type: "",
                    jzmj: "",
                    min_price: "",
                    max_price: "",
                    describe: "",
                    pic: [],
                    room_cx: '',
                    room_num: '',
                    sort: '',
                },
                rules: {},
                projectId: null,
                dialogVisibles: false,
                tableDatabed: [],
                bedloadings: false,
                roomid: "",
                badnames: "",
                dialogVisibled: false,
                sex_options: [{
                        id: 1,
                        name: '男'
                    },
                    {
                        id: 2,
                        name: '女'
                    }
                ],
                ruleForms: {
                    bed_num: "",
                    status: "",
                    sort: '',
                    user_sex: '',
                    enter_date: ''
                },
                ruled: {},
                badid: "",
                fjids: '',
                cwids: '',

            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
            that.search();
            that.getbuilding();
            // that.getfloor();
            that.getroom();
            that.getroom_cx()
        },
        methods: {
            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this;
                that.ruleForm.describe = param;
            },
            // begin(){
            //     let that = this;
            //     that.loadings = true
            //     axios
            //         .post(
            //             "/admin/lgProjectRoom/index", {
            //                 project_id:that.ruleForm.project_id,
            //                 ld_id:that.building,
            //                 lc_id:that.floor,
            //                 room_cx:that.room_cx,
            //                 limit: that.pageSize,
            //                 page: that.curPage,
            //             }, {
            //                 token: true,
            //             }
            //         )
            //         .then((response) => {
            //             that.loadings = false
            //             that.tableData = response.data.data.data;
            //             that.count = response.data.data.total;
            //         })
            //         .catch((error) => {});
            // },
            searchs(){
                let that = this
                that.pageSize = 10
                that.curPage = 1
                that.search()
            },
            search() {
                let that = this;
                that.loadings = true
                axios
                    .post(
                        "/admin/lgProjectRoom/index", {
                            project_id: that.ruleForm.project_id,
                            ld_id: that.building,
                            lc_id: that.floor,
                            room_cx: that.room_cx,
                            limit: that.pageSize,
                            page: that.curPage,
                            limit: that.pageSize,
                            page: that.curPage,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.loadings = false
                        that.tableData = response.data.data.data;
                        that.count = response.data.data.total;
                    })
                    .catch((error) => {});
            },
            handleSizeChange(val) {
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.curPage = val
                that.search()
            },
            getbuilding() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectFloor/index", {
                            project_id: that.ruleForm.project_id
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.building_options = response.data.data;
                        that.getfloor()
                    })
                    .catch((error) => {});
            },
            getfloor() {
                let that = this;
                that.building_options.forEach(element => {
                    if (that.ruleForm.building_id == element.id || that.building == element.id) {
                        that.floor_options = element.child
                    }
                });

                // axios
                //     .post(
                //         "/admin/DictionaryModel/RightList", {
                //             source: "content",
                //             sys_id: 1,
                //             type_id: 2,
                //         }, {
                //             token: true,
                //         }
                //     )
                //     .then((response) => {
                //         that.floor_options = response.data.data;
                //     })
                //     .catch((error) => {});
            },
            getroom() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectRoomType/indexList", {
                            project_id:that.ruleForm.project_id,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.room_options = response.data.data;
                    })
                    .catch((error) => {});
            },
            getroom_cx() {
                let that = this;
                axios
                    .post(
                        "/admin/DictionaryModel/RightList", {
                            source: "content",
                            sys_id: 3,
                            type_id: 6,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.room_cx_options = response.data.data;
                    })
                    .catch((error) => {});
            },
            chooseImage(param) {
                let data = param;
                this.app.chooseImage((res) => {
                    this.ruleForm.pic = [];
                    this.ruleForm.pic.push(res[0].url);
                }, 1)
            },

            openModel() {
                let that = this;
                that.names = "新增";
                that.operateflag = "add";
                that.ruleForm.building_id = null;
                // that.ruleForm.status = null;
                that.ruleForm.floor_id = null;
                that.ruleForm.room_type = null;
                that.ruleForm.jzmj = null;
                that.ruleForm.room_cx = null
                that.ruleForm.pic = [];
                that.ruleForm.min_price = null;
                that.ruleForm.max_price = null;
                that.ruleForm.describe = "";
                that.ruleForm.room_num = "";
                that.ruleForm.sort = "";
                that.dialogVisible = true;
            },
            subForm() {
                let that = this;
                let param = {
                    // id: 0,
                    project_id: null,
                    room_cx: null,
                    building_id: null,
                    floor_id: null,
                    room_type: null,
                    jzmj: null,
                    pic: [],
                    min_price: null,
                    max_price: null,
                    describe: "",
                    // status: '',
                    room_num: '',
                    sort: '',
                };
                let apiUrl = "/admin/lgProjectRoom/Madd";
                param = that.ruleForm;
                if (that.names == "编辑") {
                    param.id = that.ruleForm.id;
                    apiUrl = "/admin/lgProjectRoom/Medit";
                }

                axios
                    .post(apiUrl, param, {
                        token: true,
                    })
                    .then((response) => {
                        if (response.data.code == 200) {
                            this.$message({
                                showClose: true,
                                type: "success",
                                message: response.data.msg,
                            });
                            that.dialogVisible = false;
                   
                   
                            that.search();

                        } else {
                            this.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {});
            },
            handleClick(row) {
                let that = this;
                that.getbuilding()
                that.names = "编辑";
                that.operateflag = "edit";
                that.ruleForm.id = row.id;
                that.ruleForm.room_cx = row.room_cx
                // that.ruleForm.status = row.status
                that.ruleForm.room_num = row.room_num
                that.ruleForm.sort = row.sort
                that.ruleForm.project_id = row.project_id;
                that.ruleForm.building_id = row.building_id;
                that.ruleForm.floor_id = row.floor_id;
                that.ruleForm.room_type = row.room_type;
                that.ruleForm.jzmj = row.jzmj;
                that.ruleForm.pic = [];
                if (row.pic != null) {
                    let dataPic = Object.values(row.pic);
                    that.ruleForm.pic = dataPic;
                }
                that.ruleForm.min_price = row.min_price;
                that.ruleForm.max_price = row.max_price;
                that.ruleForm.describe = row.describe;
                that.dialogVisible = true;
            },
            // deleteClick() {},
            setClick(row) {
                let that = this;
                that.dialogVisibles = true;
                that.roomid = row.id;
                that.bedloadings = true;
                axios
                    .post(
                        "/admin/lgProjectRoomBed/index", {
                            room_id: that.roomid,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableDatabed = response.data.data;
                        that.bedloadings = false;
                    })
                    .catch((error) => {});
            },
            setClicks() {
                let that = this;
                that.bedloadings = true;
                axios
                    .post(
                        "/admin/lgProjectRoomBed/index", {
                            room_id: that.roomid,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableDatabed = response.data.data;
                        that.bedloadings = false;
                    })
                    .catch((error) => {});
            },
            openModelbad() {
                let that = this;
                that.dialogVisibled = true;
                that.badnames = "新增床位设置";
                that.ruleForms.bed_num = "";
                that.ruleForms.sort = "";
                that.ruleForms.status = "";
                that.ruleForms.user_sex = "";
                that.ruleForms.enter_date = "";
            },
            subFormbad() {
                let that = this;
                if (that.badnames == "新增床位设置") {
                    axios
                        .post(
                            "/admin/lgProjectRoomBed/Madd", {
                                // id: that.badnames == "新增床位设置" ? 0 : that.badid,
                                room_id: that.roomid,
                                bed_num: that.ruleForms.bed_num,
                                sort: that.ruleForms.sort,
                                status: that.ruleForms.status,
                                user_sex: that.ruleForms.user_sex,
                                enter_date: that.ruleForms.enter_date,
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.dialogVisibled = false;
                                that.setClicks();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }
                if (that.badnames == "修改床位设置") {
                    axios
                        .post(
                            "/admin/lgProjectRoomBed/Medit", {
                                id: that.badid,
                                room_id: that.roomid,
                                bed_num: that.ruleForms.bed_num,
                                sort: that.ruleForms.sort,
                                status: that.ruleForms.status,
                                user_sex: that.ruleForms.user_sex,
                                enter_date: that.ruleForms.enter_date,
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.dialogVisibled = false;
                                that.setClicks();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }

            },
            handleClickbed(row) {
                let that = this;
                that.dialogVisibled = true;
                that.badnames = "修改床位设置";
                that.badid = row.id;
                that.ruleForms.bed_num = row.bed_num;
                that.ruleForms.sort = row.sort;
                that.ruleForms.user_sex = row.user_sex;
                that.ruleForms.enter_date = row.enter_date;
                that.ruleForms.status = row.status.toString();
            },
            deleteClick(row) {
                let that = this
                that.fjids = row.id
                this.$confirm('此操作将永久删除该房间,和该房间下的所有床位，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(
                            "/admin/lgProjectRoom/Mdel", {
                                ids: [that.fjids],
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.search();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            deleteClickbed(row) {
                let that = this
                that.cwids = row.id
                this.$confirm('此操作将永久删除该床位, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(
                            "/admin/lgProjectRoomBed/Mdel", {
                                ids: [that.cwids],
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.setClicks();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            }
        },
    };
</script>

<style></style>